(ns nl.mediquest.lib.router.navigation-protection
  (:require
   [nl.mediquest.lib.effects :as-alias effects]
   [re-frame.core :as re-frame]))

(defn- prevent-close-page
  "Function must not be anonymous for addEventListener to de-duplicate
  Some browsers do not follow spec and expect a return value before showing
  the unsaved warning prompt. Contents of the return value are ignored."
  [^js ev]
  (.preventDefault ev)
  (set! (.-returnValue ev) ""))

(re-frame/reg-fx
 ::register-beforeunload-fx
 #(js/addEventListener "beforeunload" prevent-close-page #js {:capture true}))

(re-frame/reg-fx
 ::deregister-beforeunload-fx
 #(js/removeEventListener "beforeunload" prevent-close-page #js {:capture true}))

(re-frame/reg-sub
 ::protected-location
 (fn [db]
   (::protected-location db)))

(defn- conj-fx-in-context
  [fx context]
  (update-in context [:effects :fx] (fnil conj []) fx))

(defn- get-current-location
  []
  (let [location (.-location js/window)]
    (str
     (.-pathname location)
     (.-search location)
     (.-hash location))))

(def register
  (re-frame/->interceptor
   {:id ::register
    :after (comp
            #(assoc-in % [:effects :db ::protected-location] (get-current-location))
            (partial conj-fx-in-context [::register-beforeunload-fx]))}))

(def deregister
  (re-frame/->interceptor
   {:id ::deregister
    :after (comp
            #(update-in % [:effects :db] dissoc ::protected-location)
            (partial conj-fx-in-context [::deregister-beforeunload-fx]))}))

(re-frame/reg-event-fx
 ::turn-on
 [register]
 (fn [{:keys [db]} [_ {:keys [on-success] :as _opts}]]
   (merge {:db db}
          (when on-success
            {:dispatch on-success}))))

(re-frame/reg-event-fx
 ::turn-off
 [deregister]
 (fn [{:keys [db]} [_ {:keys [on-success] :as _opts}]]
   (merge {:db db}
          (when on-success
            {:dispatch on-success}))))

(re-frame/reg-event-fx
 ::protect
 (fn [{:keys [db]} [_ active? opts]]
   (when (not= (boolean active?)
               (boolean (get db ::protected-location)))
     {:fx [[:dispatch [(if active? ::turn-on ::turn-off) opts]]]})))

(re-frame/reg-event-fx
 ::leave-to-destination
 [deregister]
 (fn [{:keys [db]} [_ destination]]
   {:db (dissoc db ::protected-location) ; necessary before redirect effect
    :fx [[::effects/internal-redirect destination]]}))
